import * as actionTypes from '../constants/index';
const setCMDdata = data => {
	return {
		type: actionTypes.CMD_DATA,
		data
	};
};

export { setCMDdata };
